<app-enfaf-modal
  [title]="'Nuevo Usuario'"
  (onClose)="confirmCloseModal()"
  (onConfirm)="saveUser()"
  [svgIcon]="'modal-user'"
  [disableConfirmButton]="adminForm.invalid || isSavingAdmin"
  buttonConfirmText="Crear Usuario"
>
  <form class="container" [formGroup]="adminForm" autocomplete="off">
    <div class="custom-row">
      <enfaf-input
        label="Nombre"
        placeholder="Nombre"
        [control]="adminForm.controls.name"
        name="name"
        autocomplete="off"
        [errorLabel]="'Nombre requerido'"
        color="light"
      >
      </enfaf-input>
      <enfaf-input
        label="Apellidos"
        placeholder="Apellidos"
        [control]="adminForm.controls.lastname"
        name="lastname"
        autocomplete="off"
        [errorLabel]="'Apellidos requeridos'"
        color="light"
      >
      </enfaf-input>
    </div>
    <div class="custom-row">
      <enfaf-input
        label="Email de usuario"
        placeholder="Email de usuario"
        [control]="adminForm.controls.email"
        name="email"
        autocomplete="off"
        [errorLabel]="adminForm.controls.email.hasError('required') ? 'Email de usuario requerido' : 'Email no válido'"
        color="light"
      >
      </enfaf-input>
      <enfaf-select-light
        label="Rol de usuario"
        [control]="adminForm.controls.role"
        [options]="roleOptions"
        errorLabel="Rol de usuario requerido"
      ></enfaf-select-light>
    </div>
  </form>
</app-enfaf-modal>
